app.service("IndividualProductService", ['$rootScope', function ($rootScope) {

    const modelConstructor = $rootScope.model_constructor;

    const IndividualProductModel = modelConstructor.extend(modelConstructor.RouteModel, {
        name: "Individual Product",
        id: "individual_product",
        navigation_pointer: "individual_product_id",
        show_with_children: true,
        allow_single_choice_route: true
    });

    this.factory = new modelConstructor.RouteFactory({

        birth: function (values) {
            return new IndividualProductModel(values);
        }
    })

}]);